import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './LegalPage.css';

export const TermsPage: React.FC = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, []);

  return (
    <div className="legal-page">
      <header className="legal-header">
        <Link to="/" className="legal-logo">
          <img src="/logo-transparent-no-slogan.png" alt="HypeDirector" />
        </Link>
        <Link to="/" className="legal-back-link">
          Back to Home
        </Link>
      </header>

      <section className="legal-section">
        <div className="legal-container">
          <h1>Terms of Service</h1>
          <span className="legal-updated">Last updated: 2026-01-28</span>

          <p>
            These Terms of Service ("Terms") govern your use of the HypeDirector app and related services.
          </p>

          <h2>1. Eligibility</h2>
          <p>
            You must be legally able to enter a contract where you live. If the app provides links to
            betting offers/odds, you may need to be <strong>18+ or 21+</strong> depending on your jurisdiction.
            You are responsible for complying with local laws.
          </p>

          <h2>2. Your account</h2>
          <p>
            You're responsible for safeguarding your login credentials and for activity that happens
            under your account. Tell us immediately if you suspect unauthorized access.
          </p>

          <h2>3. What HypeDirector provides</h2>
          <p>
            HypeDirector helps you discover and jump to key moments in live sessions. Sessions and
            streams are provided by Owners (rights holders / creators), and moments are tagged by Spotters.
          </p>
          <p>
            We do not guarantee that every moment will be captured, that timing will be exact, or that
            all sessions will be available at all times.
          </p>

          <h2>4. Third-party services and links</h2>
          <p>The app may link to:</p>
          <ul>
            <li>Official streams (e.g., YouTube, Twitch, broadcaster sites)</li>
            <li>Odds / betting offers</li>
            <li>Other third-party websites or apps</li>
          </ul>
          <p>
            We do not control third-party services and are not responsible for their content,
            availability, or policies.
          </p>

          <h2>5. Subscriptions and billing</h2>
          <p>
            If you subscribe, billing is handled through a third-party payment provider. Subscription
            terms (price, renewal, cancellation) are shown at purchase time. You can manage your
            subscription through your account settings or your device app store (as applicable).
          </p>

          <h2>6. Acceptable use</h2>
          <p>You agree not to:</p>
          <ul>
            <li>Misuse the service (spam, scraping, reverse engineering, unauthorized access)</li>
            <li>Interfere with service operation or security</li>
            <li>Use the app in ways that violate laws or third-party rights</li>
          </ul>

          <h2>7. Intellectual property</h2>
          <p>
            We and our licensors own the app and its content (except user-provided content). You receive
            a limited, non-exclusive license to use the app for personal, non-commercial purposes.
          </p>

          <h2>8. Disclaimers</h2>
          <p>
            The service is provided "as is" and "as available". We disclaim warranties to the maximum
            extent allowed by law.
          </p>

          <h2>9. Limitation of liability</h2>
          <p>
            To the maximum extent allowed by law, HypeDirector is not liable for indirect, incidental,
            special, consequential, or punitive damages, or loss of data, revenue, or profits.
          </p>

          <h2>10. Termination</h2>
          <p>
            We may suspend or terminate access if you violate these Terms or if needed to protect the
            service. You may stop using the app at any time.
          </p>

          <h2>11. Changes</h2>
          <p>
            We may update these Terms. If changes are material, we will provide notice where required.
          </p>

          <h2>12. Contact</h2>
          <p>
            Questions: visit our <Link to="/contact">Contact</Link> page.
          </p>

          <div className="legal-notice">
            <h3>Questions About These Terms?</h3>
            <p>
              We want you to fully understand your rights and obligations. If anything is unclear,
              please contact us.
            </p>
            <Link to="/contact" className="btn-contact">Contact Us</Link>
          </div>
        </div>
      </section>
    </div>
  );
};
